<template>
    <div>
        <div class="mb-6">
            <h6 class="has-text-grey is-uppercase">Form Title</h6>
            <b-field>
                <b-input size="is-large" expanded v-model="component.title"/>
            </b-field>
        </div>

        <!-- CONTENT -->
        <b-collapse animation="slide">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Content</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <content-blocks :blocks="component.content.content"/>
            </div>

        </b-collapse>

        <b-collapse animation="slide" class="mt-6">
            <template #trigger="props">
                <div role="button" class="collapse-header">
                    <h6 class="has-text-grey is-uppercase is-pulled-left">Options</h6>
                    <p class="is-pulled-right">
                        <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                    </p>
                    <p class="is-clearfix"></p>
                </div>
            </template>

            <div class="content">
                <b-field><b-switch v-model="component.content.attributes.require_approval" true-value="1" false-value="0">Once complete, require additional approval before they can move on.</b-switch></b-field>
                <b-field><b-switch v-model="component.content.attributes.require_signature" true-value="1" false-value="0">Require a signature agreeing to a condition before completing.</b-switch></b-field>

                <div class="columns" v-if="component.content.attributes.require_signature === '1'">
                    <div class="column is-offset-1">
                        <b-field label="Signature Clause"><b-input expanded type="textarea" v-model="component.content.attributes.signature_clause"></b-input></b-field>
                    </div>
                </div>
            </div>
        </b-collapse>

    </div>

</template>

<script>
    import ContentBlocks from "../ContentBlocks.vue";


    export default {
        components: {ContentBlocks},
        props: ['component'],
        data: function() {
            return {
                content: {

                },
                require_approval: false,
                require_signature: false
            };
        }
    };
</script>

<style lang="scss" scoped>
    .collapse-header {
        border-bottom: 2px solid #e7e7e7;
        padding-bottom: 0;
        margin-bottom: 20px;

        i {
            padding: 0 10px;
        }
    }
</style>
